<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn_160">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
        collapse-tags
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-cascader
        class="select_btn_style"
        v-model="filters.categoryId"
        placeholder="图书分类"
        :options="videoCategoryData"
        :props="{
          label: 'name',
          value: 'id',
          children: 'children',
          checkStrictly: true,
        }"
        clearable
      >
      </el-cascader>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.sharedStatus"
        placeholder="共享状态"
      >
        <el-option
          v-for="(item, i) in sharedData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="图书/作者名称"
      ></el-input>
    </el-form-item>
    <el-form-item class="m-l-14">
      <butn btntype="primary" title="查询" @click="searchBook"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { resCategoryTree } from "@/api/rescategory";
import { getEnums } from "@/utils/common.js";

export default {
  components: { butn },
  data() {
    return {
      filters: {},
      sharedData: [],
      videoCategoryData: [],
      onlineStatusData: [],
      showName: "",
      defaultProps: {
        children: "children",
        label: "name",
      },
      typeList: [],
    };
  },
  created() {
    resCategoryTree({ categoryType: 1, display: 1 }).then((res) => {
      if (!res || res.code != 0) return;
      this.videoCategoryData = res.data;
    });
    getEnums(
      ["SHARED_SCREEN_STATUS", "ONLINE_STATUS", "DISPLAY_CLIENT_TYPE"],
      this,
      ["sharedData", "onlineStatusData", "typeList"],
      [true, true, true]
    );
  },
  methods: {
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
        this.filters.categoryId = data.id;
        this.showName = data.name;
      }
    },
    resetData() {
      //重置
      this.showName = "";
      this.filters = {};
      this.searchBook();
    },
    searchBook() {
      if (
        this.filters.displayClientTypes &&
        this.filters.displayClientTypes.includes("")
      ) {
        delete this.filters.displayClientTypes;
      }
      this.$emit("search", {
        ...this.filters,
        t: new Date().getTime(),
        categoryId: this.filters.categoryId
          ? JSON.parse(JSON.stringify(this.filters.categoryId)).pop()
          : "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
.tree-content {
  max-height: 400px;
  overflow: auto;
}
.sel-button {
  cursor: pointer;
  width: 118px;
  height: 30px;
  text-align: center;
  background: #edf2f9;
  border-radius: 2px;
  border: 1px solid #d7dbe0;
}
</style>
